/**
 * `ScoreLegend` — the 1/2/3 score key, shared by the Import Detail contacts
 * table and the AI Review scores table.
 *
 * This file was `AnnexBar.tsx` and exported an `AnnexBar` alongside: a strip of
 * chips naming the annex columns present for an import.
 *
 * TWO PULL REQUESTS on Trello #711 deleted that component independently and for
 * the same reason, which is worth recording because the duplication was the
 * point. #780 removed it because `CriteriaBox` renders the same column names
 * one row higher — two bordered boxes, same list, neither clickable. cl.5
 * removed it because Jared asked for the criteria to be stated as the SENTENCES
 * the recruiter typed, and a strip of column headers in schema vocabulary
 * ("annex") is what he was reading instead.
 *
 * #780 kept the filename, arguing a rename would touch two importers for
 * nothing. The rename happens here anyway, now that the merge has settled: the
 * file exports exactly one component and is named after a different one, which
 * is how the legend gets deleted next time somebody clears out the annex bar's
 * last traces. Two importers is the whole cost.
 *
 * The legend itself is NOT a smaller version of the bar: it explains what the
 * score VALUES mean, which nothing else on either page does.
 */

export function ScoreLegend() {
  return (
    <div
      data-testid="score-legend"
      className="flex flex-wrap items-center gap-4 text-caption text-text-muted"
    >
      <span>1 = definitely no</span>
      <span>2 = maybe</span>
      <span>3 = definitely yes</span>
    </div>
  );
}
